import { useState } from "react"
import { DOWNLOAD_TYPES, INPUTS } from "hooks/budgeting/useDownloadBudgetConfig"

export const useExcelOptions = ({ downloadBudgetConfig }) => {
  const tipo = DOWNLOAD_TYPES.EXCEL
  const [clientPrice, setClientPrice] = useState(
    downloadBudgetConfig[tipo][INPUTS.CLIENT_PRICE],
  )

  const [costPrice, setCostPrice] = useState(
    downloadBudgetConfig[tipo][INPUTS.COST_PRICE],
  )

  const [decomposition, setDecomposition] = useState(
    downloadBudgetConfig[tipo][INPUTS.PART_DECOMPOSITION],
  )

  const [measure, setMeasure] = useState(
    downloadBudgetConfig[tipo][INPUTS.MEASURES],
  )

  const [comments, setComments] = useState(
    downloadBudgetConfig[tipo][INPUTS.COMMENTS],
  )

  return {
    clientPrice,
    setClientPrice,
    costPrice,
    setCostPrice,
    decomposition,
    setDecomposition,
    measure,
    setMeasure,
    comments,
    setComments,
  }
}
